export enum SurveyContext {
  COMMUNITY_ACTION = 0,
  ANNUAL_MONITORING = -1,
  IMMEDIATE_EXIT_OUTSIDE_FSE = -2,
  IMMEDIATE_EXIT_FSE = -3,
}

export const labelsBySurveyContext: Map<SurveyContext, string> = new Map<SurveyContext, string>([
  [SurveyContext.COMMUNITY_ACTION, 'Action'],
  [SurveyContext.ANNUAL_MONITORING, 'Suivi annuel (FSE)'],
  [SurveyContext.IMMEDIATE_EXIT_OUTSIDE_FSE, 'Sortie immédiate (hors FSE)'],
  [SurveyContext.IMMEDIATE_EXIT_FSE, 'Sortie immédiate (FSE)'],
]);
